import TargetingSearchFormReducer from './TargetingSearchFormReducer';

export default from './TargetingSearchFormContainer';
export const TargetingSearchFormReducers = {
  TargetingSearchFormReducer,
};
